import {defineMessages} from 'react-intl'

export default defineMessages({
    modalTitle: {
        id: 'containers.ProjectView.modal.title',
        defaultMessage: 'Share your project',
    },
    modalBody: {
        id: 'containers.ProjectView.modal.body',
        defaultMessage:
            'Copy & paste your unique link below to share your project with people via. e-mail, Slack, WhatsApp or on any other platform.',
    },
    modalBodyVoting: {
        id: 'containers.ProjectView.modal.body.voting',
        defaultMessage:
            'Do you want to collect feedback or confirmation from a client or your colleagues?',
    },
    requestVotesBody: {
        id: 'containers.ProjectView.modal.votesBody',
        defaultMessage:
            'Recipients will be able to cast their vote on thir preferred voices. To be notified of submitted votes, make sure to share you e-mail below.',
    },
    shareLinkedIn: {
        id: 'containers.ProjectView.share.linkedin',
        defaultMessage: 'Send on LinkedIn',
    },
    shareEmail: {
        id: 'containers.ProjectView.share.email',
        defaultMessage: 'Share in e-mail',
    },
    close: {
        id: 'containers.ProjectView.share.close',
        defaultMessage: 'Close',
    },
    emailSubject: {
        id: 'containers.ProjectView.share.email.subject',
        defaultMessage: 'Here is some great voices for our project!',
    },
    emailBody: {
        id: 'containers.ProjectView.share.email.body',
        defaultMessage:
            'I picked out some voices for our project in VoiceArchives new Voicefinder:\n\n{url}',
    },
    emailLabel: {
        id: 'containers.ProjectPage.components.form.email.label',
        defaultMessage: "Enter your e-mail"
    },
    emailDiscription: {
        id: 'containers.ProjectPage.components.form.email.description',
        defaultMessage: "We need your e-mail to notify you on new votes."
    },
    submitText: {
        id: 'containers.ProjectPage.components.form.submit.text',
        defaultMessage: "Create link"
    },
})
